import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import { supOrgAccEditFun } from '../../../api/supportAdmin';

export default async function orgRegSubmit(formData, setLoading) {
    setLoading(true);
    try {
        let data = formData;
        // let type =
        //     formData.type === 'Trip'
        //         ? 'trip'
        //         : formData.type === 'Guide'
        //           ? 'guid'
        //           : formData.type === 'Camp'
        //             ? 'camp'
        //             : 'trip';
        // data.logo = await fileUpload(formData.logo, type, 'logo');
        // console.log(data, formData);
        const res = await supOrgAccEditFun(data);
        if (res.status === 200) {
            toast.success('Organizer Details Edit Successfully');
            setLoading(false);
            return res;
        } else {
            toast.error('Error while Registering Organizer, Please try after some time');
            setLoading(false);
        }
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}

export async function orgStatusEdit(formData, setLoading) {
    setLoading(true);
    try {
        const res = await supOrgAccEditFun(formData);
        if (res.status === 200) {
            toast.success('Account Status Changed Successfully');
            setLoading(false);
            return res;
        } else {
            toast.error('Error while Changing the status, Please try after some time');
            setLoading(false);
        }
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}
